<template>
    <div>
        <Modal
             class-name="vertical-center-modal "
            :value="showModel"
            :title="title"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="cancel"
            @on-visible-change="openOrClose"  :styles="{'min-width':'900px'}">
    
            <div class="flexC" style="justify-content: flex-end" v-if='roleType==1'>
                <div style="position:relative;z-index:50">
                   <Icon type="ios-options" @click="showCheckboxSelect =!showCheckboxSelect" size='24' color='#4ABAF0' class="optionsIcon" :title='$t("deviceManage.filter")' />
                   <div class="CheckboxSelect" v-if='showCheckboxSelect'>
                       <tableColumnFilter  :filterFiled='titleName2' :defaultCheck='defaultCheckList' @filter-field-change="refreshTable"></tableColumnFilter>
                   </div>
                </div>
                <Icon type="ios-download" size='24' @click="exportData" color='#4ABAF0' class="optionsIcon"  :title='$t("deviceManage.export")' />
                <Icon type="ios-print" size='24'  @click="print('div_print')" color='#4ABAF0' class="optionsIcon"  :title='$t("deviceManage.print")' />
            </div>
            
           <Table  max-height="450" border :columns="titleName" :data="detailList"  :loading='loading' ref="tableshow"></Table>
    
           <div id='div_print' v-show="0">
                <Table  :columns="titleName" :data="detailList"  ref="table"></Table>
            </div>
    
           <div class="totalNum" v-if='local=="en-US"'>Total {{totalNum}} items</div>
           <div class="totalNum" v-else>共 {{totalNum}} 条</div>
    
        </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import tableColumnFilter from './tableColumnFilter.vue'; 
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        components: {
            tableColumnFilter
        },
        data() {
            return {   
                loading:false,
                detailList:[],
                title: '',//弹框标题
                formData:{},
                totalNum:'20',
                showCheckboxSelect:false,
                titleName:[],
                defaultCheckList:[],
                selectedFieldList:[]
            }
        },
        watch:{
            showModel(val){
                if(val){
                    let id = this.editFormData.orderId || this.editFormData.orderName
                    this.title = this.$t('orderManage.detailModel.title')+ id

                    this.getData(this.editFormData.orderId || this.editFormData.id);
                    if(this.roleType==2){
                        this.titleName = this.titleName1
                    }else{
                        this.titleName = this.titleName2
                        this.titleName2.map(item=>{
                             this.defaultCheckList.push(item.title)
                        })
                    }
                }else{
                    this.resetForm();//重置表单
                }
            },
  
        },
        computed:{
            local(){
                return this.$store.state.local
            },
            roleType(){
                // console.log(7777)
	        	 let res = '2'
	        	 if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        		 res = this.$store.state.uInfo.roleType
	        	 }
	        	 return res
	         },
             titleName1(){
                 return [
                    {
                        title: this.$t('orderManage.detailModel.serialNumber'),
                        key: 'serialNumber',
                        minWidth: 120,
                        render:(h,params)=>{
                            return h('div',{attrs:{title:params.row.serialNumber}},params.row.serialNumber)
                        }
                    },
                    {
                        title: this.$t('orderManage.detailModel.macAddress'),
                        key: 'macAddress',
                        minWidth: 120,
                        render:(h,params)=>{
                            return h('div',{attrs:{title:params.row.macAddress}},params.row.macAddress)
                        }
                    }
                ]
             },
             titleName2(){
                 return [
                      {
                        title: this.$t('orderManage.detailModel.serialNumber'),
                        key: 'serialNumber',
                        minWidth: 180,
                        render:(h,params)=>{
                            return h('div',{attrs:{title:params.row.serialNumber}},params.row.serialNumber)
                        }
                    },
                    {
                        title: this.$t('orderManage.detailModel.macAddress'),
                        key: 'macAddress',
                        minWidth: 180,
                        render:(h,params)=>{
                            return h('div',{attrs:{title:params.row.macAddress}},params.row.macAddress)
                        }
                    },
                     {
                        title: this.$t('orderManage.detailModel.deviceId'),
                        key: 'deviceId',
                        minWidth: 330,
                         render:(h,params)=>{
                            return h('div',{attrs:{title:params.row.deviceId}},params.row.deviceId)
                        }
                    },
                     {
                        title: 'ProductKey',
                        key: 'loraProductKey',
                        minWidth: 200,
                         render:(h,params)=>{
                            return h('div',{attrs:{title:params.row.loraProductKey || ''}},params.row.loraProductKey || '')
                        }
                    },
                    {
                        title: this.$t('orderManage.detailModel.mqttPassword'),
                        key: 'mqttPassword',
                        minWidth: 200,
                         render:(h,params)=>{
                            return h('div',{attrs:{title:params.row.mqttPassword}},params.row.mqttPassword)
                        }
                    }
                 ]
             }

        },
        created(){
           
        },
        methods: {
            refreshTable(selectedField) { //过滤字段，刷新表格显示内容
                //  console.log('selectedField',selectedField)
                let showField = [];
                this.selectedFieldList = selectedField = Array.from(selectedField)
                for(let i=0;i<this.titleName2.length;i++){
                    for(let j=0;j<selectedField.length;j++){
                        if(this.titleName2[i].title==selectedField[j]){
                            showField.push(this.titleName2[i])
                        }
                    }
                }
    
                if (showField.length) {
                    showField.sort((a, b) => {
                      return a.customOrder > b.customOrder
                    })
                }
                this.defaultCheckList = selectedField
                //序号和操作固定
                this.titleName = [...showField];
            },
            exportData() { //导出
                let dataList = JSON.parse(JSON.stringify(this.detailList))
                this.$refs.tableshow.exportCsv({
                    filename: this.title,
                    original: false,  //是否导出为原始数据,默认为true
                    columns: this.titleName,
                    data: dataList.map((item) => {
                        //对数据二次加工
                        
                        let hasSerialNumber = false
                        this.titleName.map(item=>{
                            if(item.key == 'serialNumber'){
                                hasSerialNumber = true
                            }
                        })
                        if(hasSerialNumber){
                            item.serialNumber = '= "'+(item.serialNumber.toUpperCase())+'"' // csv文件处理数值的数据时，默认数值型，要转成字符串，用：="字符串内容"。比如：'="+20"' 
                        }
                        return item;
                    })
                });
            },
            print(printpage){//打印
                 var print= document.getElementById(printpage);
                 var newContent = print.innerHTML;
                 var oldContent = document.body.innerHTML;
                 document.body.innerHTML = newContent;
                 document.getElementsByTagName('body')[0].style.zoom=0.92;
                 window.print();
                 window.location.reload();
                 //将原有页面还原到页面
                //  document.body.innerHTML = oldContent;
                 return false;
    
            },
            getData(id){
                
                let params= {
                        page:1,
                        limit:10,
                        id:id
                    }
                
                this.loading = true
                this.axios.post(this.config.urlArray.orderdataDetail, params).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{
                        

                        let resData = result.data.data
                        this.detailList = resData
                        this.totalNum = resData.length
                        this.loading = false
                    });
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
                
            },
            openOrClose(value) {
               
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                this.defaultCheckList = []
                this.showCheckboxSelect = false
            }
        }
    }
</script>
<style  lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
.totalNum{
    margin-top: 20px;
    font-weight: bold;
}
 @media print {
        .el-table thead.is-group th {
            text-align: center
        }
        tbody {
            text-align: center;
            border: 1px solid #000;
        }
        th {
            border: 1px solid #000;
        }
        td {
            border: 1px solid #000;
        }
    }
</style>